import i18n from '@/shared/i18n';
import BaseModel from '@/core/components/input-widget/BaseModel';

export default class VendorChargeTier extends BaseModel {
  amount_over = 0;
  percent = null;
  flat_price = 0;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  getData() {
    return {
      amount_over: parseFloat(this.amount_over),
      percent: parseFloat(this.percent),
      flat_price: parseFloat(this.flat_price),
    };
  }

  rules = {
    amount_over: 'required',
    percent: 'max_value:100|min_value:0',
    flat_price: 'decimal:2'
  };

  attributeLabels = {
    amount_over: i18n.t('Over'),
    percent: i18n.t('Percentage'),
    flat_price: i18n.t('Flat Price'),
  };
}
